<template>
  <div class="filter-date-preset" v-bind:class="cssClass">
    <multiselect :placeholder="'Select a date range'"
                 :options="options"
                 :track-by="'key'"
                 :label="'label'"
                 @select="setDateRange"
                 :allow-empty="false"
                 :searchable="false"
                 :deselect-label="''"
                 :value="selection"></multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Moment from 'moment'

export default {
  name: 'filterDatePreset',
  props: {
    'cssClass': {
      type: String,
      required: false,
      default: ''
    },
    'defaultOption': {
      type: Object,
      required: false
    }
  },

  data: function () {
    return {
      selection: this.defaultOption,
      options: [
        this.defaultOption,
        { key: '2023', label: '2023' },
        { key: '2022', label: '2022' },
        { key: '2021', label: '2021' },
        { key: '2020', label: '2020' },
        { key: '2019', label: '2019' },
        { key: '2018', label: '2018' },
        { key: '2017', label: '2017' },
        { key: '2016', label: '2016' },
        { key: '2015', label: '2015' },
        { key: '2014', label: '2014' },
        { key: '2013', label: '2013' },
        { key: '2012', label: '2012' },
        { key: '2011', label: '2011' },
        { key: '2010', label: '2010' },
        { key: '2009', label: '2009' },
        { key: '2008', label: '2008' },
        { key: '2007', label: '2007' },
        { key: '2006', label: '2006' },
        { key: 'all', label: 'All (2006 - 2023)' }
      ]
    }
  },

  components: {
    'Multiselect': Multiselect
  },

  methods: {
    setDateRange (value) {
      let startDate = ''
      let endDate = Moment()

      if (value.key === 'all') {
        startDate = Moment('2006-01-01')
        endDate = Moment('2023-06-01')
      } else if (value.key === '2023') {
        // == 2023 data only available to June.
        startDate = Moment(`${value.key}-01-01`)
        endDate = Moment(`${value.key}-06-01`)
      } else {
        startDate = Moment(`${value.key}-01-01`)
        endDate = Moment(`${value.key}-12-31`)
      }

      this.selection = {key: value.key, label: value.label}
      this.$store.dispatch('filterDateRange/setStartDate', startDate.format('YYYY-MM-DD'))
      this.$store.dispatch('filterDateRange/setEndDate', endDate.format('YYYY-MM-DD'))
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/FilterDatePreset";
</style>



// WEBPACK FOOTER //
// FilterDatePreset.vue?0b3ebbb0